const initialState = { events: [], prospectListOnAgent: [], hydrated: false };
const calendarReducer = (state, action) => {
  if (!state || !state.hydrated) {
    state = {
      ...initialState,
      ...state,
      hydrated: true,
    };
  }
  function check(all, singledata) {
    if (all.some((i) => i.eventId === singledata.eventId)) {
      let index = all.findIndex((i) => i.eventId === singledata.eventId);
      all[index] = singledata;
    } else {
      all = [...all, singledata];
    }
    return all;
  }
  if (action.type === "SET_EVENTDATA") {
    return {
      events: check(state.events, action.payload),
    };
  }
  if (action.type === "LOADPROSPECTONAGENT") {
    return {
      ...state,
      prospectListOnAgent: action.payload.data,
    };
  }
  if (action.type === "SET_CALENDER_PARAMETER") {
    return {
      ...state,
      [action.payload.type]: action.payload.data,
    };
  } else if (action.type === "LOAD_EVENTS") {
    return {
      ...state,
      events: action.payload.data,
    };
  } else {
    return state;
  }
};
export default calendarReducer;
